declare global {
  interface Window {
    appConfig: {
      siteName: string;
      siteTitle: string;
      favicon: string;
      themeColor: string;
      description: string;
      apiUrl: string;
      companyId: string;
      storageUrl: string;
      whatsapp: { number: string; message: string };
      googleMapsApiKey: string;
      tracking: {
        facebookPixelId: string;
        googleAnalyticsId: string;
        googleTagManagerId: string;
      };
    };
  }
}

const getConfig = () => window.appConfig || {};

export const getApiUrl = (): string => {
  const cfg = getConfig();
  if (cfg.apiUrl) return cfg.apiUrl;

  const env = process.env.REACT_APP_NODE_ENV || 'local';
  switch (env) {
    case 'production':
      return process.env.REACT_APP_API_PRODUCTION_URL || '';
    case 'developer':
      return process.env.REACT_APP_API_DEVELOPER_URL || '';
    default:
      return process.env.REACT_APP_API_LOCAL_URL || 'http://127.0.0.1:8000/api';
  }
};

export const getApiDomain = (): string => {
  const cfg = getConfig();
  if (cfg.apiUrl) return cfg.apiUrl;
  const env = process.env.REACT_APP_NODE_ENV || 'local';
  switch (env) {
    case 'production':
      return process.env.REACT_APP_API_DOMAIN_PRODUCTION_URL || '';
    case 'developer':
      return process.env.REACT_APP_API_DOMAIN_DEVELOPER_URL || '';
    default:
      return process.env.REACT_APP_API_DOMAIN_LOCAL_URL || 'http://127.0.0.1:8000/api';
  }
};

export const getCompanyId = (): string =>
  getConfig().companyId || process.env.REACT_APP_COMPANY_ID || '';

export const getStorageUrl = (): string =>
  getConfig().storageUrl || process.env.REACT_APP_STORAGE_URL || '';

export const getWhatsAppUrl = (): string => {
  const cfg = getConfig();
  const number = cfg.whatsapp?.number || process.env.REACT_APP_WHATSAPP_NUMBER || '';
  const message = cfg.whatsapp?.message || process.env.REACT_APP_WHATSAPP_MESSAGE || '';
  return `https://wa.me/${number}?text=${encodeURIComponent(message)}`;
};

export const api = {
  get: async (endpoint: string) => {
    const res = await fetch(`${getApiUrl()}${endpoint}`);
    if (!res.ok) throw new Error(`HTTP ${res.status}`);
    return res.json();
  },
  post: async (endpoint: string, body: any) => {
    const res = await fetch(`${getApiUrl()}${endpoint}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
    });
    if (!res.ok) throw new Error(`HTTP ${res.status}`);
    return res.json();
  },
};
